import { useAuth } from "context/AuthContext";
import ToolBarRate from "../Rate/ToolBarRate";
import ThemeButton from "./ThemeButton";
import UserDropDown from "./UserDropDown"

const ToolBarRightContainer = () => {
    
    const { auth } = useAuth();

    return (
        <div>
            <ul className="list-unstyled">
                <li><ToolBarRate/></li>
                <li><ThemeButton/></li>                 
                <li><UserDropDown/></li> 
            </ul>
        </div>
    )
}

export default ToolBarRightContainer;